import {Stack, Typography} from "@mui/material";
import {GridOverlay} from "@mui/x-data-grid-premium";

declare module '@mui/x-data-grid-premium' {
    interface NoRowsOverlayPropsOverrides {
        /** A second, muted line under the "No evidence on file" title. */
        hint?: string;
    }
}

type EvidenceNoRowsOverlayProps = {
    hint?: string;
};

/** The evidence table's empty state (`MithraGrid` `emptyTitle` + `emptyText` in the design). */
export function EvidenceNoRowsOverlay({hint}: EvidenceNoRowsOverlayProps) {
    return (
        <GridOverlay>
            <Stack gap={0.5} sx={{alignItems: 'center', px: 2, textAlign: 'center'}}>
                <Typography variant="body2" fontWeight={600}>No evidence on file</Typography>
                {hint && <Typography variant="caption" color="text.secondary">{hint}</Typography>}
            </Stack>
        </GridOverlay>
    );
}
